'use client';

import { PropsWithChildren, useState } from 'react';

import { Button, Typography, useMediaQuery } from '@mui/material';
import { Box } from '@mui/system';

export const ResolutionWarning = ({ children }: PropsWithChildren) => {
  const [ignoreWarning, setIgnoreWarning] = useState(true);
  const checkResolution = useMediaQuery(
    '(min-width: 1920px) && (min-heignt: 1080px)'
  );

  if (!checkResolution && !ignoreWarning) {
    return (
      <Box
        sx={{
          '@media screen and (max-height: 1330px)': {
            visibility: 'visible',
          },
          visibility: 'hidden',
          width: '100%',
          height: '100vh',
          background: 'black',
          position: 'absolute',
          top: 0,
          left: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
        }}
      >
        <Typography
          variant="h3"
          sx={{ textAlign: 'center', color: 'white', maxWidth: '60%' }}
          gutterBottom
        >
          Conformément aux conditions générales d'utilisation de Clubhouse par
          Score'n'co, la taille minimale de votre écran doit-être de 1920x1080
          pixels (27 pouces).
        </Typography>
        <Button
          variant="contained"
          onClick={() => {
            setIgnoreWarning(true);
          }}
        >
          Ignorer
        </Button>
      </Box>
    );
  }

  return <>{children}</>;
};
